export default __webpack_public_path__ + "static/media/photosynthesis.8e30e576.jpg";